export default __webpack_public_path__ + "static/media/iconUpload.9a70b4be.svg";